import {Component, OnInit} from '@angular/core';
import {
  Aangifte,
  AangifteRapport, BokkzAlgDataService, IncomeTaxEntity,
  OpbouwVerliescompensatie,
  SpecificatieVerliescompensatie
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder} from "@angular/forms";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-verliescompensatie',
  templateUrl: './spec-verliescompensatie.component.html',
  styleUrls: ['./spec-verliescompensatie.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule
  ]
})
export class SpecVerliescompensatieComponent implements OnInit {
    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    specVerliescompensatieFormGroup = this.fb.group<AangifteRapport>({});
    specVerliescompensatie = {} as AangifteRapport;

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder) {
        this.specVerliescompensatieFormGroup = this.fb.group<AangifteRapport>(({
            specificatieVerliescompensatie: this.fb.group<SpecificatieVerliescompensatie>(({
                opbouw: this.fb.group<OpbouwVerliescompensatie>(({
                    verrekendVerliesBox1: null as unknown as number,
                    verrekendVerliesBox2: null as unknown as number,
                    verrekendVerliesBox1JaarMinNegen: null as unknown as number,
                    nogTeVerrekenenVerliesBox1JaarMinNegen: null as unknown as number,
                    verrekendVerliesBox1JaarMinAcht: null as unknown as number,
                    nogTeVerrekenenVerliesBox1JaarMinAcht: null as unknown as number,
                    verrekendVerliesBox1JaarMinZeven: null as unknown as number,
                    nogTeVerrekenenVerliesBox1JaarMinZeven: null as unknown as number,
                    verrekendVerliesBox1JaarMinZes: null as unknown as number,
                    nogTeVerrekenenVerliesBox1JaarMinZes: null as unknown as number,
                    verrekendVerliesBox1JaarMinVijf: null as unknown as number,
                    nogTeVerrekenenVerliesBox1JaarMinVijf: null as unknown as number,
                    verrekendVerliesBox1JaarMinVier: null as unknown as number,
                    nogTeVerrekenenVerliesBox1JaarMinVier: null as unknown as number,
                    verrekendVerliesBox1JaarMinDrie: null as unknown as number,
                    nogTeVerrekenenVerliesBox1JaarMinDrie: null as unknown as number,
                    verrekendVerliesBox1JaarMinTwee: null as unknown as number,
                    nogTeVerrekenenVerliesBox1JaarMinTwee: null as unknown as number,
                    verrekendVerliesBox1JaarMinEen: null as unknown as number,
                    nogTeVerrekenenVerliesBox1JaarMinEen: null as unknown as number,
                    nogTeCompenserenVerliesBox1DitJaar: null as unknown as number,
                    verrekendVerliesBox2JaarMinNegen: null as unknown as number,
                    nogTeVerrekenenVerliesBox2JaarMinNegen: null as unknown as number,
                    verrekendVerliesBox2JaarMinAcht: null as unknown as number,
                    nogTeVerrekenenVerliesBox2JaarMinAcht: null as unknown as number,
                    verrekendVerliesBox2JaarMinZeven: null as unknown as number,
                    nogTeVerrekenenVerliesBox2JaarMinZeven: null as unknown as number,
                    verrekendVerliesBox2JaarMinZes: null as unknown as number,
                    nogTeVerrekenenVerliesBox2JaarMinZes: null as unknown as number,
                    verrekendVerliesBox2JaarMinVijf: null as unknown as number,
                    nogTeVerrekenenVerliesBox2JaarMinVijf: null as unknown as number,
                    verrekendVerliesBox2JaarMinVier: null as unknown as number,
                    nogTeVerrekenenVerliesBox2JaarMinVier: null as unknown as number,
                    verrekendVerliesBox2JaarMinDrie: null as unknown as number,
                    nogTeVerrekenenVerliesBox2JaarMinDrie: null as unknown as number,
                    verrekendVerliesBox2JaarMinTwee: null as unknown as number,
                    nogTeVerrekenenVerliesBox2JaarMinTwee: null as unknown as number,
                    verrekendVerliesBox2JaarMinEen: null as unknown as number,
                    nogTeVerrekenenVerliesBox2JaarMinEen: null as unknown as number,
                    nogTeCompenserenVerliesBox2DitJaar: null as unknown as number,
                    verrekendeBuitenlandseBronheffing: null as unknown as number,
                    nogTeVerrekenenBuitenlandseBronheffing: null as unknown as number,
                } as OpbouwVerliescompensatie))
            } as SpecificatieVerliescompensatie))
        } as AangifteRapport))
    }

    public ngOnInit(): void {
        this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte as Aangifte;
                this.aangifte = aangifte;
                this.dataService.aangifteRapport.subscribe((value) => {
                    this.specVerliescompensatie = value;
                    this.specVerliescompensatieFormGroup.patchValue(this.specVerliescompensatie)
                });
            }
        });
    }

}

